import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './UserAvatar.css';

export interface UserAvatarProps {
    link: string;
    width: number;
    height: number;
    cls?: string;
    rounded?: boolean;
    resize?: number;
}

const BLOCK = 'user-avatar';

export class UserAvatar extends React.PureComponent<UserAvatarProps> {
    render() {
        const { link, width, height, cls, rounded, resize } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: BLOCK,
                        mods: { rounded: rounded || false }
                    }),
                    cls
                )}
                style={{
                    backgroundImage: `url(${link})`,
                    width: width,
                    height: height,
                    backgroundSize: `${resize || 100}%`
                }}
            />
        );
    }
}
